import React from 'react';
import { ICategoryNews, INews } from '@/api/home/types';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { Routes } from '@/routes';
import { ItemsContainer } from '@/components/common/ItemsContainer';
import { News } from './News';

export const NewsList = ({
  title,
  news,
  weatherNews,
}: {
  title?: string,
  news: Array<INews>,
  weatherNews?: boolean,
}) => {
  const { t } = useOTSTranslation('common');

  // Two CTA modes shipped in the same component:
  // - `weatherNews` carousels link to /weather with a domain-specific
  //   label.
  // - Anything else (when a title is set) links to /magazine with the
  //   generic "Load more" label.
  let viewAllHref: string | undefined;
  let viewAllLabel: string | undefined;
  if (weatherNews) {
    viewAllHref = Routes.weather;
    viewAllLabel = t('snowWeather.home.viewAllWeatherNews');
  } else if (title) {
    viewAllHref = Routes.magazine;
    viewAllLabel = t('common.loadMore');
  }

  return (
    <section className="mt-4 md:max-lg:px-4">
      <ItemsContainer
        title={title}
        viewAllHref={viewAllHref}
        viewAllLabel={viewAllLabel}
      >
        {news.map((item: INews | ICategoryNews) => (
          <ItemsContainer.Item key={item.uuid}>
            <News news={item} />
          </ItemsContainer.Item>
        ))}
      </ItemsContainer>
    </section>
  );
};
